module.exports = __webpack_public_path__ + "static/media/quadrant-devs-hobbyist-hacker.a6726a86.svg";